<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.displayName }}
        </p>
        <span class="user-status">{{ userData.perfil === 'administrador' ? 'admin' : userData.perfil }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar ? require(`@/assets/images/avatars/${userData.avatar}`) : null"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.displayName"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'conta-configuracao' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>{{ $t('Ajustes') }}</span>
    </b-dropdown-item>

    <b-dropdown-item
      :to="{ name: 'conta-assinatura' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="AlertCircleIcon"
        class="mr-50"
      />
      <span>{{ $t('Assinatura') }}</span>
    </b-dropdown-item>

    <b-dropdown-item
      :to="{ name: 'suporte' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="HeadphonesIcon"
        class="mr-50"
      />
      <span>{{ $t('Suporte') }}</span>
    </b-dropdown-item>

    <b-dropdown-divider />

    <b-dropdown-item
      id="logout"
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('Sair') }}</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'
import { getContext } from '@/auth/utils'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
      getContext,
    }
  },

  methods: {

    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem('cb-products')
      localStorage.removeItem('cb-context')
      localStorage.removeItem(useJwt.jwtConfig.storageImpersonateKeyName)

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>
